import {Component, Input, ViewChild} from '@angular/core';
import { Chart } from 'chart.js';
import {isNumeric} from "rxjs/util/isNumeric";

/**
 * Generated class for the StatsFoodGraphComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'stats-food-graph',
  templateUrl: 'stats-food-graph.html'
})
export class StatsFoodGraphComponent {

  @Input()
  week: any;

  @Input()
  data: any;

  @ViewChild('chartGeneral') generalChart;

  constructor() {
  }

  getGraphConfigTemplate () {
    return {
      type: 'scatter',
      data: {
        labels: ['M','D','M','D','F','S','S'],
        datasets: [{
          data: [1,2,3,4,5,6], //(weekData['graphs'] && weekData['graphs']['group1'])?weekData['graphs']['group1']['points']:[],
          borderColor: '#55a446',// array should have same number of elements as number of dataset
          borderWidth: 6,
          pointRadius: 1,
          pointBorderWidth: 4,
          fill: false,
          showLine: true,
        },{
          data: [6,5,4,3,2], //(weekData['graphs'] && weekData['graphs']['group2'])?weekData['graphs']['group2']['points']:[],
          borderColor: '#ed9800',// array should have same number of elements as number of dataset
          borderWidth: 6,
          pointRadius: 1,
          pointBorderWidth: 4,
          fill: false,
          showLine: true
        },{
          data: [3,3,3,3,3,3], //(weekData['graphs'] && weekData['graphs']['group2'])?weekData['graphs']['group2']['points']:[],
          borderColor: '#d2442e',// array should have same number of elements as number of dataset
          borderWidth: 6,
          pointRadius: 1,
          pointBorderWidth: 4,
          fill: false,
          showLine: true
        }]
      },
      /*plugins: [{
        beforeRender: (x, options) => {
          const c = x.chart;
          const dataset = x.data.datasets[0];
          const yScale = x.scales['y-axis-0'];
          const yPos = 10;

          const gradientFill = c.ctx.createLinearGradient(0, 0, 0, c.height);
          gradientFill.addColorStop(0, 'rgb(86,188,77)');
          gradientFill.addColorStop(yPos / c.height, 'rgb(86,188,77)');
          gradientFill.addColorStop(yPos / c.height, 'rgb(229,66,66)');
          gradientFill.addColorStop(1, 'rgb(229,66,66)');

          const model = x.data.datasets[0]._meta[Object.keys(dataset._meta)[0]].dataset._model;
          model.borderColor = gradientFill;
        },
      }],*/
      options: {
        aspectRatio: 1,
        elements: {
          line: {
            tension: 0
          }
        },
        legend: {
          display: false,
        },
        layout: {
          padding: {
            left: 20,
            right: 20,
          }
        },

        plugins: {
          title: {
            display: false,
          },
          legend: {
            display: false,
          }
        },
        scales: {
          xAxes: [{
            gridLines: {
              display: false
            },
            ticks: {
              min: 1,
              max: 7,
              stepSize: 1,
              callback: function(key) {
                return ['M','D','M','D','F','S','S'][key-1];
              }
            },
          }],
          yAxes: [{
            ticks: {
              mirror: true,
              stepSize: 1,
              suggestedMax: 10,
              padding: 20,
              beginAtZero: true,
            }
          }]
        }
      }
    };
  }

  processValueArray(data) {
    if(isNumeric(data[0])) {
      return data.map((v, k) => { if(v) return {x: k+1, y: v}}).filter(v => v);
    }
    return data;
  }

  ngOnInit() {
    console.log('did load', this.data);
    let graphConfig = this.getGraphConfigTemplate();

    if(this.data && this.data[0]) {
      graphConfig.data.datasets[0].data = this.processValueArray(this.data[0]);
    }
    if(this.data && this.data[1]) {
      graphConfig.data.datasets[1].data = this.processValueArray(this.data[1]);
    }
    if(this.data && this.data[2]) {
      graphConfig.data.datasets[2].data = this.processValueArray(this.data[2]);
    }
    this.generalBar = new Chart(this.generalChart.nativeElement, graphConfig);
  }
  generalBar: any;

  ngOnChanges() {
    console.log('data changes', this.data);
    if(!this.generalBar) {
      return ;
    }
    if(this.data && this.data[0]) {
      this.generalBar.data.datasets[0].data = this.processValueArray(this.data[0]);
    }
    if(this.data && this.data[1]) {
      this.generalBar.data.datasets[1].data = this.processValueArray(this.data[1]);
    }
    if(this.data && this.data[2]) {
      this.generalBar.data.datasets[2].data = this.processValueArray(this.data[2]);
    }
    console.log('data updated', this.generalBar);
    this.generalBar.update();
  }


}



// WEBPACK FOOTER //
// ./src/components/stats-food-graph/stats-food-graph.ts